
import { defineComponent } from 'vue';
import LeftArrowIcon from './LeftArrowIcon.vue';
import RightArrowIcon from './RightArrowIcon.vue';
import CloseIcon from './CloseIcon.vue';
import VideoIcon from './VideoIcon.vue';

// let Hammer

// if (typeof window !== 'undefined') {
//   Hammer = require('hammerjs')
// }

export default defineComponent({
  emits: ['onImageChanged', 'selected', 'onLoad', 'onOpened', 'onClosed', 'onStartIndex', 'onFirstIndex', 'onLastIndex'],
  components: {
    LeftArrowIcon,
    RightArrowIcon,
    CloseIcon,
    VideoIcon,
  },
  props: {
    media: {
      type: Array,
      required: true,
    },

    disableScroll: {
      type: Boolean,
      default: true,
    },

    disableZoom: {
      type: Boolean,
      default: true,
    },

    showLightBox: {
      type: Boolean,
      default: true,
    },

    closable: {
      type: Boolean,
      default: true,
    },

    startAt: {
      type: Number,
      default: 0,
    },

    nThumbs: {
      type: Number,
      default: 7,
    },

    showThumbs: {
      type: Boolean,
      default: true,
    },

    showFooterCount: {
      type: Boolean,
      default: true,
    },

    // Mode
    autoPlay: {
      type: Boolean,
      default: false,
    },

    autoPlayTime: {
      type: Number,
      default: 3000,
    },

    siteLoading: {
      type: String,
      default: '',
    },

    showCaption: {
      type: Boolean,
      default: false,
    },

    lengthToLoadMore: {
      type: Number,
      default: 0,
    },

    closeText: {
      type: String,
      default: 'Close (Esc)',
    },

    previousText: {
      type: String,
      default: 'Previous',
    },

    nextText: {
      type: String,
      default: 'Next',
    },

    previousThumbText: {
      type: String,
      default: 'Previous',
    },

    nextThumbText: {
      type: String,
      default: 'Next',
    },
  },

  data() {
    return {
      select: this.startAt,
      lightBoxOn: this.showLightBox,
      timer: null as any,
      modalImageTransitionName: 'vue-lb-modal-image-no-transition',
    };
  },

  computed: {
    thumbIndex() {
      const halfDown = Math.floor(this.nThumbs / 2);

      if (this.select >= halfDown && this.select < this.media.length - halfDown)
        return {
          begin: this.select - halfDown + (1 - (this.nThumbs % 2)),
          end: this.select + halfDown,
        };

      if (this.select < halfDown)
        return {
          begin: 0,
          end: this.nThumbs - 1,
        };

      return {
        begin: this.media.length - this.nThumbs,
        end: this.media.length - 1,
      };
    },

    imagesThumb() {
      if (this.siteLoading) {
        return (this.media as any).map(({ thumb, type }) => ({
          src: thumb,
          type,
          loading: this.siteLoading,
          error: this.siteLoading,
        }));
      }

      return (this.media as any).map(({ thumb, type }) => ({
        src: thumb,
        type,
      }));
    },
  },

  watch: {
    lightBoxOn(value) {
      if (document != null) {
        this.onToggleLightBox(value);
      }
    },

    select() {
      this.$emit('onImageChanged', this.select);

      if (this.select >= this.media.length - this.lengthToLoadMore - 1) this.$emit('onLoad');

      if (this.select === this.media.length - 1) this.$emit('onLastIndex');

      if (this.select === 0) this.$emit('onFirstIndex');

      if (this.select === this.startAt) this.$emit('onStartIndex');
    },
  },

  mounted() {
    if (this.autoPlay) {
      this.timer = setInterval(() => {
        this.nextImage();
      }, this.autoPlayTime);
    }

    this.onToggleLightBox(this.lightBoxOn);

    // if (this.$refs.container) {
    //   const options = {};
    //   if (!this.disableZoom) {
    //     options.touchAction = 'pan-x, pan-y';
    //   }

    //   const hammer = new Hammer(this.$refs.container, options)
    //   hammer.on('swiperight', () => {
    //     this.previousImage()
    //   })

    //   hammer.on('swipeleft', () => {
    //     this.nextImage()
    //   })
    // }
  },

  beforeUnmount() {
    document.removeEventListener('keydown', this.addKeyEvent);

    if (this.autoPlay) {
      clearInterval(this.timer);
    }
  },

  methods: {
    onLightBoxOpen() {
      this.$emit('onOpened');

      if (this.disableScroll) {
        document.querySelector('html')?.classList.add('no-scroll');
      }
      document.querySelector('body')?.classList.add('vue-lb-open');
      document.addEventListener('keydown', this.addKeyEvent);

      if (this.$refs.video && (this.$refs.video as any).autoplay) {
        (this.$refs.video as any).play();
      }
    },

    onLightBoxClose() {
      this.$emit('onClosed');

      if (this.disableScroll) {
        document.querySelector('html')?.classList.remove('no-scroll');
      }

      document.querySelector('body')?.classList.remove('vue-lb-open');
      document.removeEventListener('keydown', this.addKeyEvent);

      if (this.$refs.video) {
        (this.$refs.video as any).pause();
        (this.$refs.video as any).currentTime = 0;
      }
    },

    onToggleLightBox(value) {
      if (value) {
        this.onLightBoxOpen();
      } else {
        this.onLightBoxClose();
      }
    },

    showImage(index) {
      this.select = index;
      this.lightBoxOn = true;
    },

    addKeyEvent(event) {
      if (event.keyCode === 37) this.previousImage(); // left arrow
      if (event.keyCode === 39) this.nextImage(); // right arrow
      if (event.keyCode === 27) this.closeLightBox(); // esc
    },

    closeLightBox() {
      if (!this.closable) return;
      this.lightBoxOn = false;
    },

    nextImage() {
      this.select = (this.select + 1) % this.media.length;
    },

    previousImage() {
      this.select = (this.select + this.media.length - 1) % this.media.length;
    },

    enableImageTransition() {
      this.modalImageTransitionName = 'vue-lb-modal-image-transition';
    },

    disableImageTransition() {
      this.modalImageTransitionName = 'vue-lb-modal-image-no-transition';
    },
  },
});
